module.exports = __webpack_public_path__ + "img/Vectordab.2d281ea4.png";